import React, { useContext, useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive'
import { useHistory, useRouteMatch } from 'react-router-dom';

import Markup from '../../markup';
import Tooltip from '../Global/Tooltip';
import { device } from '../../const/device';
import BuilderContext from '../../builder/hooks/context';

function Color() {
  const history = useHistory();
  const { params } = useRouteMatch<{ type: string, id: string }>();
  const { builder } = useContext(BuilderContext);

  const [selectedPalette, setSelectedPalette] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const [prevColor, setPrevColor] = useState(builder.modelData.colorList.get(params.id));

  useEffect(() => {
    setSelectedPalette('');
    setOpenActivePalette(false);
  },[params.id])

  const [openActivePalette, setOpenActivePalette] = useState(false);

  const isTablet = useMediaQuery({ query: `(${device.tablet})` })
  const currentPalette =  builder.modelData.palette.find(({ color }) => selectedPalette === color);


  const goBack = () => {
    if(selectedColor){
      onSelectedColor(prevColor);
    }
    history.goBack();
  }

  const onSelectedColor = (hex:string) => {
    setSelectedColor(hex);
    if (params.type === 'text') {
      builder.membersData.setMemberTextColors( prevColors => ({...prevColors, [params.id]: hex }))
    } else if (params.type === 'layer') {
      builder?.modelData?.setColor(params.id, hex);
    }
  }

  const onSelectedPalete = (color:string) => {
    if(isTablet) setOpenActivePalette(true);
    setSelectedPalette(color)
  }

  const mobileSubmit = () => {
    if (openActivePalette) {
      history.goBack();
    } else {
      setOpenActivePalette(true);
    }
  }

  const mobileBack = () => {
    if (openActivePalette) {
      setOpenActivePalette(false);
    } else {
      goBack();
    }
  }

  const isDisabledSubmit = () => (!currentPalette  || selectedColor === "" ? true: false);
  const isDisabledMobileSubmit = () => (!currentPalette || (openActivePalette && selectedColor === "") ? true: false);

  return (
    <>
      <Markup.Screen.Logos.NoticeMessageTabs themeColor={builder.membersData.colorTheme} disOverOther={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}>
        Unable to make changes to this item because it has already been added to cart
      </Markup.Screen.Logos.NoticeMessageTabs>
      <Markup.Screen.Name.DisableOverlayOther themeColor={builder.membersData.colorTheme} disOverOther={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}>
      </Markup.Screen.Name.DisableOverlayOther>
      <Markup.Screen.Color.Header>
        <Markup.Global.Button.ButtonIconClose tabletOnly onClick={mobileBack} />

        <Markup.Screen.Color.TitleContainer themeColor={builder.membersData.colorTheme}>
          Select {openActivePalette ? currentPalette?.name : 'Color'}
          <Tooltip Icon={Markup.Global.Link.LinkHelpIcon} width={isTablet ? 320 : 366} offset={ isTablet ? -190 : -100} bottom>
            <Markup.Screen.Color.HelpTextContainer>
              <b>Please note:</b> that whilst we maintain a very high level of accuracy, colours and
              design that you see on screen may slightly differ to the actual product due to variances between the RGB and
              CMYK colour space.
            </Markup.Screen.Color.HelpTextContainer>
          </Tooltip>
        </Markup.Screen.Color.TitleContainer>

        <Markup.Global.Button.ButtonIconSubmit disabled={isDisabledMobileSubmit()} tabletOnly onClick={mobileSubmit} />

        <Markup.Screen.Color.IconContainer>
          <Markup.Global.Button.ButtonIconLeftArrow onClick={goBack} />
          <Markup.Global.Button.ButtonIconSubmit disabled={isDisabledSubmit()} onClick={() =>  history.goBack()} />
        </Markup.Screen.Color.IconContainer>
      </Markup.Screen.Color.Header>

      {/*<Markup.Screen.Color.Group>
        <Markup.Global.ColorPicker.Wrapper>
          <Markup.Global.ColorPicker.Item color='#ff0000' big />
          <Markup.Global.ColorPicker.Title>Gamertag</Markup.Global.ColorPicker.Title>
        </Markup.Global.ColorPicker.Wrapper>
        <Markup.Global.ColorPicker.Wrapper>
          <Markup.Global.ColorPicker.Item color='#ff0000' big />
          <Markup.Global.ColorPicker.Title>Full Name</Markup.Global.ColorPicker.Title>
        </Markup.Global.ColorPicker.Wrapper>
        <Markup.Global.ColorPicker.Wrapper>
          <Markup.Global.ColorPicker.Item color='#ff0000' big />
          <Markup.Global.ColorPicker.Title>Number</Markup.Global.ColorPicker.Title>
        </Markup.Global.ColorPicker.Wrapper>
      </Markup.Screen.Color.Group>*/}

      {!isTablet || (isTablet && !openActivePalette) ?
        <Markup.Screen.Color.Wrapper>
          {builder.modelData.palette
            .map(({ color }) =>
              <Markup.Global.ColorPicker.Item
                key={color}
                active={color === selectedPalette}
                onClick={() => onSelectedPalete(color)}
                color={color}
                big
                themeColor={builder.membersData.colorTheme}
              />
            )
          }
        </Markup.Screen.Color.Wrapper>
      : ''}

      {(selectedPalette && !isTablet) || (isTablet && selectedPalette && openActivePalette) ?
        <Markup.Global.Palette.Container>
          <Markup.Global.Palette.Title>Select {currentPalette?.name}</Markup.Global.Palette.Title>
          <Markup.Global.Palette.List>
            {currentPalette.palette
              .map(([hexColor]) =>
                <Markup.Global.Palette.Item
                  key={hexColor}
                  onClick={() => onSelectedColor(hexColor)}
                  active={hexColor === selectedColor}
                  color={hexColor}
                />
              )
            }
          </Markup.Global.Palette.List>
          <Markup.Global.Palette.Button onClick={() => setSelectedPalette('')} />
        </Markup.Global.Palette.Container>
      : ''}
    </>
  );
}

export default React.memo(Color);
